// extracted by mini-css-extract-plugin
export default {"innerWrapper":"BB-z","tooltipWrapper":"CB-z","icon":"DB-z","tooltip":"EB-z","content":"FB-z"};